export const PUMP_TYPE = {
	FIRE: "FIRE",
	WATER: "WATER",
	DRAINAGE: "DRAINAGE"
}